import React from 'react';
import { HeaderLogoData } from '../../../../../../components/blackrock/advisor-center/_types/header';

import './HeaderLogo.scss';

export type HeaderLogoType = {
	logo: HeaderLogoData;
};

const HeaderLogo: React.FC<HeaderLogoType> = ({ logo }) =>
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	logo?.path && (
		<div className="blk-ac-header-logo front-of-bg">
			<a data-final-url href={logo.homeLink} title={logo.homeLinkTitle}>
				<img alt={logo.alt} src={logo.path} data-final-url />
			</a>
		</div>
	);

export default HeaderLogo;
